import axios from "axios";
import { getAuthHeaders, getEnhancedAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;
const token = localStorage.getItem("token");
const userId = localStorage.getItem("userId");

export const getAllSensors = async () => {
  try {
    const sensors = await axios.get(`${backendUrl}/sensors`, {
      headers: getAuthHeaders(),
    });
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllSensorsByCompanyId = async (companyId) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/company/${companyId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllSensorsWithNoMesDataByContainerId = async (containerId) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/containerwithnodata/${containerId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllSensorsByContainerId = async (containerId) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/container/${containerId}/${userId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getSensorDataByContainerIdWithFilters = async (
  containerId,
  filters,
) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/containerwithfiltereddata/${containerId}`,
      {
        headers: getAuthHeaders(),
        params: filters,
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getSensorDataByContainerIdWithFiltersFor3DView = async (
  containerId,
  filters,
) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/containerwithfiltereddataforthreed/${containerId}`,
      {
        headers: getEnhancedAuthHeaders(),
        params: filters,
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getSensorDataByContainerIdWithOptions = async (
  containerId,
  options = {},
) => {
  try {
    // Build query parameters
    const params = new URLSearchParams();

    if (options.startDate) {
      params.append("startDate", options.startDate.toISOString());
    }

    if (options.endDate) {
      params.append("endDate", options.endDate.toISOString());
    }

    if (options.sensorIds && options.sensorIds.length > 0) {
      params.append("sensorIds", options.sensorIds.join(","));
    }

    const response = await axios.get(
      `${backendUrl}/sensors/containerwithfiltereddata/${containerId}?${params.toString()}`,
      { headers: getAuthHeaders() },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching sensor data with filters:", error);
    throw error;
  }
};

export const getAllSensorsWithEveryDataByContainerId = async (containerId) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/containerwitheverydata/${containerId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllSensorsByDeviceId = async (deviceId) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/device/${deviceId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllSensorsWithLatestDataByDeviceId = async (
  deviceId,
  userId,
) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/sensorswithlatestdata/${deviceId}/${userId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllSensorsByContainerIdAndDeviceId = async (
  containerId,
  deviceId,
) => {
  try {
    const sensors = await axios.get(
      `${backendUrl}/sensors/container/${containerId}/device/${deviceId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return sensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getSensorById = async (sensorId) => {
  try {
    const sensor = await axios.get(`${backendUrl}/sensors/${sensorId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return sensor.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/* export const getAllActiveThresholdViolationMeasurements = async () => {
  try {
    const measurements = await axios.get(
      `${backendUrl}/sensors/thresholdviolationmeasurements`,
      {
        headers: getAuthHeaders(),
      }
    );
    return measurements.data;
  } catch (error) {
    throw new Error(error.message);
  }
}; */

export const getAllActiveThresholdViolationMeasurements = async (
  page = 1,
  limit = 10,
) => {
  try {
    const measurements = await axios.get(
      `${backendUrl}/sensors/thresholdviolationmeasurements`,
      {
        params: { page, limit },
        headers: getAuthHeaders(),
      },
    );
    return measurements.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllThresholdViolationMeasurements = async () => {
  try {
    const measurements = await axios.get(
      `${backendUrl}/sensors/thresholdviolationmeasurements/all`,
      {
        headers: getAuthHeaders(),
      },
    );
    return measurements.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// UPDATE

export const updateSensorThresholdsBySensorId = async (
  sensorId,
  thresholds,
  userId,
) => {
  try {
    const updatedSensor = await axios.patch(
      `${backendUrl}/sensors/thresholds/${sensorId}`,
      { ...thresholds, userId },
      {
        headers: getAuthHeaders(),
      },
    );
    return updatedSensor.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateEverySensorThresholdsByContainerId = async (
  containerId,
  thresholds,
) => {
  try {
    const updatedSensors = await axios.patch(
      `${backendUrl}/sensors/thresholdsincontainer/${containerId}`,
      { ...thresholds, userId },
      {
        headers: getAuthHeaders(),
      },
    );
    return updatedSensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateEverySensorThresholdsAdditiveByContainerId = async (
  containerId,
  thresholds,
) => {
  try {
    const updatedSensors = await axios.patch(
      `${backendUrl}/sensors/thresholdsadditiveincontainer/${containerId}`,
      { ...thresholds, userId },
      {
        headers: getAuthHeaders(),
      },
    );

    console.log("Updated sensors:", updatedSensors.data);
    return updatedSensors.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const acknowledgeThresholdViolationByRecordId = async (recordId) => {
  try {
    const updatedThresholdViolationRecord = await axios.patch(
      `${backendUrl}/sensors/thresholdviolationmeasurements/${recordId}`,
      {},
      {
        headers: getAuthHeaders(),
      },
    );
    return updatedThresholdViolationRecord.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const previewAcknowledgeAllThresholdViolations = async (
  recordIds = [],
) => {
  try {
    const params =
      recordIds.length > 0 ? `?recordIds=${recordIds.join(",")}` : "";
    const result = await axios.get(
      `${backendUrl}/sensors/thresholdviolationmeasurements/preview${params}`,
      { headers: getAuthHeaders() },
    );
    return result.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const acknowledgeAllThresholdViolations = async (recordIds = []) => {
  try {
    const result = await axios.patch(
      `${backendUrl}/sensors/thresholdviolationmeasurements`,
      { recordIds },
      { headers: getAuthHeaders() },
    );
    return result.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * Update a single sensor's thresholds (absolute).
 * payload: { sensorId, minThreshold, maxThreshold, userId }
 */
export const updateSingleSensorThreshold = async (containerId, payload) => {
  const response = await fetch(
    `/api/sensors/container/${containerId}/sensor/threshold`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
  if (!response.ok) throw new Error("Failed to update single sensor threshold");
  return response.json();
};

/**
 * Update a single sensor's thresholds (additive).
 * payload: { sensorId, minAdditive, maxAdditive, userId }
 */
export const updateSingleSensorThresholdAdditive = async (
  containerId,
  payload,
) => {
  const response = await fetch(
    `/api/sensors/container/${containerId}/sensor/threshold/additive`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
  if (!response.ok)
    throw new Error("Failed to update single sensor threshold additively");
  return response.json();
};

/**
 * Update all sensors in a probe (absolute).
 * payload: { probeid, minThreshold, maxThreshold, userId }
 */
export const updateProbeThresholds = async (containerId, payload) => {
  const response = await fetch(
    `/api/sensors/container/${containerId}/probe/threshold`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
  if (!response.ok) throw new Error("Failed to update probe thresholds");
  return response.json();
};

/**
 * Update all sensors in a probe (additive).
 * payload: { probeid, minAdditive, maxAdditive, userId }
 */
export const updateProbeThresholdsAdditive = async (containerId, payload) => {
  const response = await fetch(
    `/api/sensors/container/${containerId}/probe/threshold/additive`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
  if (!response.ok)
    throw new Error("Failed to update probe thresholds additively");
  return response.json();
};

export const updateSensorThresholdsBySensorIdInWarnings = async (
  sensorId,
  payload,
) => {
  try {
    const updatedSensor = await axios.patch(
      `${backendUrl}/sensors/thresholds/${sensorId}`,
      payload,
      {
        headers: getAuthHeaders(),
      },
    );
    return updatedSensor.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
